<div class="card mt-1">
  <div class="card-body">
    <app-verification-heading
      [patientAttachment]="patientAttachment"
      title="Validate Prescriber"
    />
    <app-prescriber-match-form
      [capture]="capture"
      [patientAttachment]="patientAttachment"
    />
  </div>
</div>
